import React from 'react';
import tinyFlag from 'tiny-flag';
import ifEmoji from 'emoji-supported'; // Windows does not support flag emojis, so test first.

var supportsEmoji = ifEmoji("🇺🇸");
/**
 * An accessible emoji flag, with graceful fallbacks for platforms without support for flag emojis.
 *
 * Adjust sizing using font-size.
 */

function TinyFlag(_ref) {
  var country = _ref.country,
      alt = _ref.alt,
      fallbackImageURL = _ref.fallbackImageURL;

  if (supportsEmoji) {
    try {
      return React.createElement("span", {
        role: "img",
        "aria-label": alt,
        style: {
          position: "relative"
        }
      }, tinyFlag(country));
    } catch (_a) {
      /* no-op */
    }
  }

  return React.createElement(React.Fragment, null, React.createElement("img", {
    style: {
      width: "1em",
      height: "1em"
    },
    src: fallbackImageURL,
    alt: alt
  }));
}

export default TinyFlag;